export let FloatArray = Float64Array; // or Float32Array
